import { ButtonLink } from 'components/shared/ButtonLink.styled';
import { Heading1, Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import {
  color,
  container,
  fontSize,
  screen,
  shadow,
  spacing
} from '../../../theme';

export const StyledHero = styled.section`
  position: relative;
  overflow: hidden;
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
`;

export const StyledImage = styled.div`
  position: relative;
  background-color: ${color('white')};

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl')};
  }

  ${StyledContainer} {
    background-image: ${() =>
      `url('${getPublicPath('/images/applicationsLanding/hero.svg')}')`};
    background-repeat: no-repeat;
    background-size: contain;
    aspect-ratio: 30/12;

    @media (max-width: ${screen('mdMax')}) {
      background-image: ${() =>
        `url('${getPublicPath(
          '/images/applicationsLanding/hero_mobile.svg'
        )}')`};
      background-position: center bottom;
      aspect-ratio: auto;
      background-size: cover;
      clip-path: polygon(0 0, 100% 0, 100% 95%, 0 95%);
    }
  }

  ${Heading1} {
    color: ${color('text_white')};
    text-align: center;
    padding-top: calc(${spacing('xl5')});
    padding-bottom: calc(${spacing('xl6')});

    @media (min-width: ${screen('md')}) {
      padding-top: calc(${spacing('xl5')} + ${spacing('xl')});
      padding-bottom: 0;
    }
  }
`;

export const StyledHeadingCarousel = styled.span`
  display: block;
  height: 1.35em;
  overflow: hidden;
`;

export const StyledHeadingCarouselInner = styled.span`
  display: block;
  animation: wordSlider ease-out infinite 12s;

  > span {
    display: block;
    line-height: 1.3em;
    color: ${color('text_white')};
  }

  @keyframes wordSlider {
    0%,
    16% {
      transform: translateY(0%);
    }
    20%,
    36% {
      transform: translateY(-16.66%);
    }
    40%,
    56% {
      transform: translateY(-33.33%);
    }
    60%,
    76% {
      transform: translateY(-50%);
    }
    80%,
    96% {
      transform: translateY(-66.66%);
    }
    100% {
      transform: translateY(-83.33%);
    }
  }
`;

export const StyledIntro = styled.div`
  font-size: ${fontSize('lg')};
  line-height: 1.6;
  background-image: ${() =>
    `url('${getPublicPath('/images/applicationsLanding/hero-bg.svg')}')`};
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: cover;

  @media (max-width: ${screen('mdMax')}) {
    background-image: unset;
    font-size: ${fontSize('md')};
    line-height: 1.5;
  }

  ${StyledContainer} {
    display: flex;
    flex-direction: column;
    gap: ${spacing('xl')};
    padding-top: ${spacing('xl3')};

    @media (min-width: ${screen('md')}) {
      flex-direction: row;
      justify-content: space-between;
    }

    @media (max-width: ${screen('mdMax')}) {
      padding: 0;
      > div {
        padding-top: ${spacing('xl3')};
        padding-left: ${spacing('md')};
        padding-right: ${spacing('md')};
        background-image: ${() =>
          `url('${getPublicPath('/images/applicationsLanding/hero-bg.svg')}')`};
        background-size: cover;
        background-position: left 20% top;
        padding-bottom: ${spacing('xl')};
      }
    }
  }

  ${Heading2} {
    margin-bottom: ${spacing('lg')};

    &::before {
      left: 0;
      transform: translate(0);
    }

    & ~ div {
      > :first-child {
        margin-top: 0;
      }
      > :last-child {
        margin-bottom: 0;
      }
    }
  }
  ${ButtonLink} {
    margin-top: ${spacing('xl')};
  }

  img {
    flex-shrink: 0;
    display: block;
    box-shadow: ${shadow('lg')};
    max-width: 18rem;

    @media (max-width: ${screen('mdMax')}) {
      margin: auto;
    }
  }
`;
